var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-popup',{staticClass:"tips",model:{value:(_vm.showPop),callback:function ($$v) {_vm.showPop=$$v},expression:"showPop"}},[_c('div',[_c('h2',[_vm._v("重要提醒")]),_c('h3',[_vm._v("检测到您已签署过该的协议，协议同样适用于此门课程，如有疑问请联系客服")]),_c('div',{on:{"click":_vm.knowBtn}},[_vm._v("我知道了")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }